import { Route, Routes } from 'react-router-dom'
import { AuthRoute } from '@components/Okta'
import { LoginCallback } from '@okta/okta-react'
import { ProtectedRouter } from '@routes/protected'

export const Router = () => {
  return (
    <Routes>
      <Route element={<AuthRoute />}>
        <Route path={`/login/callback`} element={<LoginCallback />} />
        <Route path="/*" element={<ProtectedRouter />} />
      </Route>
    </Routes>
  )
}
